module.exports = __webpack_public_path__ + "static/irishBeginningArranged-381a52f26c7d821e93ff28b10ece1a3b.mp3";